import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/elementor-7474")({
  beforeLoad: () => {
    throw redirect({ to: "/why-patients-travel-to-florida-for-saint-tms" });
  },
});
